import Brand from "../brand";
import {defaultTabs, NavigationTabs} from "../navigation-tabs";
import React from "react";

export default function DashboardHeader() {
    return (
        <header className="header header-sm header-divider">
            <Brand/>

            <NavigationTabs tabs={defaultTabs}/>
        </header>
    );
}